/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useEffect } from 'react'
import { Button, ButtonGroup, Spinner } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import FieldInputText from './components/FieldInputText'
import { fields } from './handlers'
import { useDataAssetForms } from './useDataAssetForm'
import { schemaValidation } from './schemaValidation'
import FormWrapper from '@/components/forms/FormWrapper'
import { joiResolver } from '@hookform/resolvers/joi'

const DataAssetForm = ({
  batchId,
  data,
  dataId,
  isEdit,
  onCancel,
  reloadBatch,
  setStage
}) => {
  const {
    onSubmit,
    setFormValues,
    hasAlert
  } = useDataAssetForms({
    batchId,
    data,
    dataId,
    isEdit,
    reloadBatch,
    setStage
  })
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
    trigger
  } = useForm({
    resolver: joiResolver(schemaValidation),
    mode: 'onChange'
  })

  useEffect(() => {
    if (data) {
      const currentData = data?.raw
        ? setFormValues(data?.raw)
        : data
      reset(currentData)
      trigger()
    }
  }, [data, reset, trigger])

  if (!data) return <Spinner size="md" />

  const dataAssetFields = fields.map(field => (
    <FieldInputText
      id={field.id}
      key={field.id}
      label={field.label}
      register={register}
      error={errors[field.id]}
    />
  ))

  return (
    <FormWrapper hasAlert={hasAlert}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          { dataAssetFields }
        </div>
        <ButtonGroup gap='4'>
          <Button
            colorScheme="gray"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button type='submit'>
            Save
          </Button>
        </ButtonGroup>
      </form>
    </FormWrapper>
  )
}

export default DataAssetForm
